import { render, staticRenderFns } from "./DesignContent1.vue?vue&type=template&id=2ce4045d&"
import script from "./DesignContent1.vue?vue&type=script&lang=ts&"
export * from "./DesignContent1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports